'use client'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { FaApple, FaGooglePlay } from 'react-icons/fa'
import Link from 'next/link'
import { IconType } from 'react-icons'
import { Button } from '../../@/components/ui/button'
import BillingAlert from '../BillingAlert/BillingAlert'
import useCompanySubscription from '../../hooks/queries/useCompanySubscription'

type Props = {
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
}

const AppDownloadModal = ({ isOpen, setIsOpen }: Props) => {
	const { companySubscription } = useCompanySubscription()
	const linkButton = (link: string, Icon: IconType, text: string) => (
		<Link href={link} rel="noopener noreferrer" target="_blank" className="flex ">
			<Button className="flex grow space-x-2">
				<Icon />
				<p>{text}</p>
			</Button>
		</Link>
	)

	const closeDialog = () => {
		setIsOpen(false)
	}

	return (
		<Dialog open={isOpen} onOpenChange={setIsOpen}>
			<DialogContent>
				<DialogHeader className="mb-2">
					<DialogTitle>Download Hit Em Up</DialogTitle>
					<BillingAlert callToAction={closeDialog} />
					<DialogDescription>{`${
						!!companySubscription ? 'Download' : 'Then download'
					} corresponding app for your device`}</DialogDescription>
				</DialogHeader>
				<div className="flex flex-0 justify-center">
					<div className="flex items-stretch sm:flex-1 flex-col sm:flex-row sm:place-content-evenly space-y-3 sm:space-y-0">
						{linkButton(
							'https://apps.apple.com/us/app/hit-em-up-personal-fast-text/id943630636',
							FaApple,
							'App Store',
						)}
						{linkButton(
							'https://apps.apple.com/us/app/hit-em-up-personal-fast-text/id943630636',
							FaApple,
							'Mac App Store',
						)}
						{linkButton(
							'https://play.google.com/store/apps/details?id=com.hitemup',
							FaGooglePlay,
							'Play Store',
						)}
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default AppDownloadModal
